module.exports = __webpack_public_path__ + "static/media/load_form.6298a600.pro";